import { EventEmitter, Injectable, Output } from '@angular/core';
import API from '../../../modules/common/services/api.config.json';
import { ApiService } from '../../../modules/common/services/api.service';
import { Observable, Subject } from 'rxjs';
import { RestResponse } from 'app/modules/common/entities/rest.response.model';
import { BehaviorSubject, } from 'rxjs/internal/BehaviorSubject';


@Injectable({
    providedIn: 'root'
})
export class ConveniosTreeViewService {
    private subjectEdited = new Subject<void>();
    private subjectTopButtons = new Subject<void>();

    constructor(
        private apiService: ApiService
    ) { }

    private convenioEdited = new BehaviorSubject(false);
    convenioEditedValue = this.convenioEdited.asObservable();
    changeEditStatus(message: boolean) {
        this.convenioEdited.next(message);
    }
    sendClickUpdateEvent() {
        this.subjectEdited.next();
    }
    getClickUpdateEvent(): Observable<any> {
        return this.subjectEdited.asObservable();
    }


    private topButtons = new BehaviorSubject(false);
    topButtonsEditValue = this.topButtons.asObservable();
    changeTopButtonEditStatus(message: boolean) {
        this.topButtons.next(message);
    }
    sendClickUpdateTopButtonsEvent() {
        this.subjectTopButtons.next();
    }
    getClickUpdateTopButtonsEvent(): Observable<any> {
        return this.subjectTopButtons.asObservable();
    }


    getConveniosTreeView(): Observable<RestResponse> {
        let url = `${API.Convenios.getConveniosTreeView}`;
        return this.apiService.get(url);
    }
    getGroups(): Observable<RestResponse> {
        let url = `${API.Convenios.getGroups}`;;
        return this.apiService.get(url);
    }
    getCriterioConvenio(convenioid: any): Observable<RestResponse> {
        let url = `${API.Convenios.getCriterioConvenio}`;
        url = url.replace('{convenioid}', convenioid);
        return this.apiService.get(url);
    }
    updateCriterioConvenio(criterio: any): Observable<RestResponse> {
        let url = `${API.Convenios.updateCriterioConvenio}`;
        return this.apiService.put(url, criterio);
    }
    addCriterioConvenio(criterio: any): Observable<RestResponse> {
        let url = `${API.Convenios.addCriterioConvenio}`;
        return this.apiService.post(url, criterio);
    }
    addConvenio(convenio: any): Observable<RestResponse> {
        let url = `${API.Convenios.addConvenio}`;
        return this.apiService.post(url, convenio);
    }
    editConvenio(convenio: any): Observable<RestResponse> {
        let url = `${API.Convenios.editConvenio}`;
        return this.apiService.put(url, convenio);
    }
    checkConvenioUsed(convenioid: any): Observable<RestResponse> {
        let url = `${API.Convenios.checkConvenioUsed}`;
        url = url.replace('{convenioid}', convenioid);
        return this.apiService.get(url);
    }
    deleteConvenioUsed(convenioid: any): Observable<RestResponse> {
        let url = `${API.Convenios.deleteConvenioUsed}`;
        url = url.replace('{convenioid}', convenioid);
        return this.apiService.delete(url);
    }
}


